import ErrorState from "components/Error/ErrorState";
import LoadingIcon from "components/Loading/LoadingIcon";
import Notes from "components/Notes";
import { lienFileToNotesEntity } from "components/Notes/notesAdapter";
import ClientInformationDrawer from "pages/client/ClientInformationDrawer/ClientInformationDrawer";
import { useEffect, useState } from "react";

import { useLienFileData } from "./hooks/useLienFileData";
import { useLiensData } from "./hooks/useLiensData";

const LienNotesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error] = useState<Error | null>(null);

  const { lienFileData } = useLienFileData();
  const { liens } = useLiensData({ fileId: lienFileData?.file_id?.toString() });

  useEffect(() => {
    if (lienFileData && liens) {
      setIsLoading(false);
    }
  }, [lienFileData, liens]);

  if (isLoading) {
    return <LoadingIcon />;
  }

  if (error) {
    return <ErrorState description={error.message} />;
  }

  if (!lienFileData) {
    return <ErrorState description="Lien file data not found" />;
  }

  const notesEntity = lienFileToNotesEntity(lienFileData);

  return (
    <>
      {notesEntity && <Notes entity={notesEntity} />}
      <ClientInformationDrawer service={lienFileData} />
    </>
  );
};

export default LienNotesPage;
